import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "grid lg:grid-cols-4 gap-2 items-center header-hjp" }
const _hoisted_2 = { class: "gap-4 sm:flex items-center col-span-1 lg:col-span-2" }
const _hoisted_3 = {
  key: 0,
  class: "title-header"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "text-white font-bold text-sm" }
const _hoisted_6 = { class: "text-primary font-bold text-sm" }
const _hoisted_7 = { class: "col-span-2 flex justify-end gap-4" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flex justify-end items-stretch input-icon-right-grey w-full" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = {
  class: "text-sm",
  style: {"white-space":"nowrap"}
}
const _hoisted_13 = { class: "w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputIconRight = _resolveComponent("InputIconRight")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.titleHeader)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_ctx.titleHeader), 1))
        : _createCommentVNode("", true),
      (_ctx.showAddBtn)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            class: "mb-2 sm:mb-0 flex gap-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirectAdd())),
            style: {"height":"-webkit-fill-available"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: _ctx.iconButton ? _ctx.iconButton : _ctx.icon.svg.plusEva
              }, null, 8, _hoisted_4),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.titleButton), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.extraButton)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 2,
            class: "flex gap-2 extra-submit-button",
            style: {"border-color":"#04776D"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectAddExtraButton())),
            outlined: true
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.titleExtraButton), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.showFilter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "background-grey-3 px-3 py-2 rounded-lg flex items-center h-full cursor-pointer",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDropDownFilter($event)))
            }, _cache[5] || (_cache[5] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("i", { class: "pi pi-filter text-sm mr-2" }),
                _createTextVNode(" Filter")
              ], -1),
              _createElementVNode("i", { class: "pi pi-angle-down text-sm ml-5" }, null, -1)
            ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.showSearch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: _normalizeClass((_ctx.canClick) ? 'background-grey-3 px-3 items-center flex left-radius cursor-pointer' : 'px-2 items-center flex left-radius'),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDropDown($event)))
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.selectedSearchParam?.label), 1),
                  _cache[6] || (_cache[6] = _createElementVNode("i", { class: "pi pi-angle-down ml-2" }, null, -1))
                ])
              ], 2),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_InputIconRight, {
                  class: "input-search-header-custom",
                  placeholder: _ctx.placeholder,
                  modelValue: _ctx.inputSearch,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputSearch) = $event)),
                  canClick: true,
                  icon: _ctx.icon.svg.searchEva,
                  onSubmitInput: _ctx.onSearch,
                  onKeyup: _withKeys(_ctx.onSearch, ["enter"])
                }, null, 8, ["placeholder", "modelValue", "icon", "onSubmitInput", "onKeyup"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}